module.exports = __webpack_public_path__ + "static/list_pic.272c1ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/list_pic.png
// module id = 3152
// module chunks = 213231404188204